var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00CDDA",
  d: "M44.45 34H3.484V7H44.45z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6FF4FD",
  d: "M12.797 20.965H7.211v2.793h5.586zM22.102 20.965h-5.586v2.793h5.586zM31.414 20.965h-5.586v2.793h5.586zM40.727 20.965H35.14v2.793h5.586zM22.108 27.483H7.21v2.793h14.897z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C2FFFF",
  d: "M40.724 27.483h-9.31v2.793h9.31z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F5BC00",
  d: "M40.723 12.587h-8.38v5.586h8.38z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6FCF97",
  d: "M39 41a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m45.79 29.081-1.834-1.76-5.507 5.683-2.744-2.61-1.76 1.834 2.734 2.602 1.835 1.75.002-.003.003.003 1.768-1.827z"
})));
export default SvgAddCard;